<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> {{ data.icon }} </span>
      <p>{{ data.textIcon }}</p>
    </div>
    <span class="material-icons float-end CloseModal" mat-dialog-close>
      close
    </span>
  </div>

  <div class="ModalContent">
    <h1 class="TtlModal">
      {{data.title}}
    </h1>
    <p class="mt-32 mb-0">{{data.text}}</p>
    <p class="mt-32 mb-0">{{data.textExtra}}</p>
  </div>

  <hr/>

  <div class="ModalContent"> 

    <!-- <ng-template *ngIf='isSafari && data.textExtra!=""'>
      <p class="mb-0">{{data.textExtra}}</p> 
      <div class="row">
        <div class="col text-center mt-32">
          <a [href]="data.linkOutAdress" target="_blank" class="text-underline" mat-dialog-close>{{data.textLink}}</a>
          <hr class="mt-24">
        </div>
      </div>
    </ng-template> -->

    <div class="row">
      <div class="col text-center mt-64 d-flex align-items-center justify-content-center">
        <button class="Btn BtnPadrao" mat-button mat-dialog-close>
          <span class="material-icons align-middle me-10">{{data.btnOneIcon}}</span>
          {{data.textBtnOne}}
        </button>
      </div>
    </div>
  </div>

</div>
